import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUpload } from "react-icons/fa";
import { IoMdPersonAdd } from "react-icons/io";
import { IoPersonRemoveSharp } from "react-icons/io5";
import "../css/others/ListMapping.css";
import "../css/others/Table.css";
import { apiCall } from "../main/ApiCall";
import axios from "axios";
import ToastPopup from "../popups/ToastPopup";
import { Users, Role, createToastMessage, ToastMessage, IAuditorSkill, IAuditorType } from '../interFaces/interfaces';
import { validateField, nameValidationRules, emailValidationRules } from '../Reusablecomponents/Validation';
import EncryptionUtils from "../main/encryptionUtils";
import SkillsModal from "../popups/SkillsModal";
const RoleMapping: React.FC = () => {
  const [showQuestion, setShowQuestion] = useState(true);
  const [showTemplateButtons, setShowTemplateButtons] = useState(false);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [uploadError, setUploadError] = useState("");
  const [roleSelection, setRoleSelection] = useState<string | null>(null);
  const [roles, setRoles] = useState<Role[]>([]);
  const [auditorSkills, setAuditorSkills] = useState<IAuditorSkill[]>([]);
  const [auditorTypes, setAuditorTypes] = useState<IAuditorType[]>([]);
  const [formData, setFormData] = useState<{ [key: string]: Users[] }>({});
  const [fieldErrors, setFieldErrors] = useState<{ [key: string]: { [key: number]: { firstName?: string; lastName?: string; email?: string; skills?: string; auditorType?: string; } } }>({});
  const [showSkillsModal, setShowSkillsModal] = useState<boolean>(false);
  const [currentSkillRowIndex, setCurrentSkillRowIndex] = useState<number | null>(null);
  const [currentSkillRole, setCurrentSkillRole] = useState<string | null>(null);
  const navigate = useNavigate();
  const [fields, setFields] = useState<any>({});
  const clientId = localStorage.getItem("clientId");
  const [showUploadWarningModal, setShowUploadWarningModal] = useState(false);
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs["roleMapping"]) {
      setFields(permissions.tabs["roleMapping"].fields);
    } else {
      console.log("No permissions found for 'roleMapping' tab");
    }
  }, []);
  useEffect(() => {
    apiCall("get", `/api/roles/all/${clientId}`)
      .then((response) => {
        if (Array.isArray(response)) {
          setRoles(response);
        } else {
          console.error("Error fetching roles:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
    apiCall("get", "/api/enums/AuditorSkillEnum")
      .then((response) => {
        if (Array.isArray(response)) {
          setAuditorSkills(response);
        } else {
          console.error("Error fetching auditor skills:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching auditor skills:", error);
      });
    apiCall("get", "/api/enums/AuditTypeEnum")
      .then((response) => {
        if (Array.isArray(response)) {
          setAuditorTypes(response);
        } else {
          console.error("Error fetching auditor types:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching auditor types:", error);
      });
  }, [clientId]);
  const handleYesClick = () => {
    setShowQuestion(false);
    setShowTemplateButtons(true);
  };
  const handleNoClick = () => {
    setShowQuestion(false);
  };
  const handleBackClick = () => {
    setShowQuestion(false);
    setShowTemplateButtons(false);
    setRoleSelection(null);
  };
  const handleRoleSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedRole = e.target.value;
    setRoleSelection(selectedRole);
    const selectedRoleName = roles.find(role => role.id === selectedRole)?.name;
    const newUser: Users = { firstName: "", lastName: "", email: "", ...(selectedRoleName === "Auditor" ? { isPrimaryAuditor: undefined, auditorType: undefined, skills: [] } : {}) };
    setFormData({ [selectedRole]: [newUser] });
    setFieldErrors({});
  };
  const handleBack = () => { navigate(-1); };
  const handleBackClickGroup = () => {
    setShowQuestion(true);
    setShowTemplateButtons(false);
    setRoleSelection(null);
    setFieldErrors({});
  };
  const handleDownloadTemplate = async () => {
    try {
      const response = await apiCall("get", "/api/bulk-upload/s3presigneddownloadurl", null, { fileName: "role_mapping_template.xlsx", action: "default" });
      const presignedUrl = response;
      if (!presignedUrl) throw new Error("Failed to retrieve presigned URL");
      const fileResponse = await axios.get(presignedUrl, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([fileResponse.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "role_mapping_template.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setMessage(createToastMessage("Template downloaded successfully.", "success", 3000));
    } catch (error) {
      setMessage(createToastMessage("Failed to download the template.", "error", 3000));
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) setFile(file);
  };
  const handleBulkUpload = async () => {
    if (!file) {
      setUploadError("Please select a file to upload.");
      return;
    }
    try {
      const presignedUrlResponse = await apiCall("get", `/api/bulk-upload/s3presigneduploadurl?fileName=${file.name}&action=user_role_creation`);
      const presignedUrl = presignedUrlResponse;
      if (!presignedUrl) {
        throw new Error("Failed to retrieve presigned upload URL.");
      }
      await axios.put(presignedUrl, file, { headers: { "Content-Type": file.type } });
      if (!clientId) {
        throw new Error("Client ID not found in localStorage.");
      }
      const urlObj = new URL(presignedUrl);
      const fileKey = decodeURIComponent(urlObj.pathname.substring(1));
      await apiCall("post", "/api/bulk-upload/complete", { clientId, fileKey });
      await apiCall("get", "/api/bulk-upload/process-messages");
      setMessage(createToastMessage("Role mapping Uploaded successfully. Go to User Management for details.", "success", 3000));
      setFile(null);
      setUploadError("");
      setTimeout(() => { window.location.reload() }, 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || error.message || "Upload failed.";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, role: string, index: number) => {
    const { name, value } = e.target;
    if (name === "auditorType") {
      setFormData((prevData) => {
        const updatedData = { ...prevData };
        if (!updatedData[role]) updatedData[role] = [];
        const updatedUser = {
          ...updatedData[role][index], [name]: value, isPrimaryAuditor: value !== "INTERNAL" ? undefined : updatedData[role][index].isPrimaryAuditor
        };
        updatedData[role][index] = updatedUser as Users;
        return updatedData;
      });
    } else {
      setFormData((prevData) => {
        const updatedData = { ...prevData };
        if (!updatedData[role]) updatedData[role] = [];
        const updatedUser = {
          ...updatedData[role][index], [name]: name === "isPrimaryAuditor" ? value === "" ? undefined : value === "true" : value
        };
        updatedData[role][index] = updatedUser as Users;
        return updatedData;
      });
    }
    if (name === 'firstName' || name === 'lastName' || name === 'email') {
      let error: string | null = null;
      if (name === 'firstName') {
        error = validateField(value, nameValidationRules, "First name");
      } else if (name === 'lastName') {
        error = validateField(value, nameValidationRules, "Last name");
      } else if (name === 'email') {
        error = validateField(value, emailValidationRules, "Email");
      }
      setFieldErrors(prev => ({ ...prev, [role]: { ...prev[role], [index]: { ...prev[role]?.[index], [name]: error || undefined } } }));
    }
  };
  const handleOpenSkillsModal = (role: string, index: number) => {
    setCurrentSkillRowIndex(index);
    setCurrentSkillRole(role);
    setShowSkillsModal(true);
  };
  const handleSaveSkills = (selectedSkills: string[]) => {
    if (currentSkillRowIndex !== null && currentSkillRole !== null) {
      setFormData((prevData) => {
        const updatedData = { ...prevData };
        if (!updatedData[currentSkillRole]) return prevData;
        const updatedUser = { ...updatedData[currentSkillRole][currentSkillRowIndex], skills: selectedSkills };
        updatedData[currentSkillRole][currentSkillRowIndex] = updatedUser as Users;
        return updatedData;
      });
      setFieldErrors(prev => ({ ...prev, [currentSkillRole!]: { ...prev[currentSkillRole!], [currentSkillRowIndex!]: { ...prev[currentSkillRole!]?.[currentSkillRowIndex!], skills: undefined } } }));
    }
    setShowSkillsModal(false);
    setCurrentSkillRowIndex(null);
    setCurrentSkillRole(null);
  };
  const getSkillDescription = (skillValue: string): string => {
    const skill = auditorSkills.find(s => s.value === skillValue);
    return skill ? skill.description : skillValue;
  };
  const getSelectedSkillsDisplay = (skills: string[]): string => {
    if (!skills || skills.length === 0) {
      return "No skills selected";
    }
    const skillDescriptions = skills.slice(0, 2).map(getSkillDescription);
    let display = skillDescriptions.join(", ");
    if (skills.length > 2) {
      display += ` +${skills.length - 2} more`;
    }
    return display;
  };
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!roleSelection) return;
    const newFieldErrors: { [key: string]: { [key: number]: { firstName?: string; lastName?: string; email?: string; skills?: string; auditorType?: string; } } } = {};
    let hasErrors = false;
    let firstErrorMessage = "";
    formData[roleSelection]?.forEach((user, index) => {
      const firstNameError = validateField(user.firstName || "", nameValidationRules, "First name");
      const lastNameError = validateField(user.lastName || "", nameValidationRules, "Last name");
      const emailError = validateField(user.email || "", emailValidationRules, "Email");
      const selectedRoleName = roles.find(r => r.id === roleSelection)?.name;
      let auditorTypeError: string | undefined;
      if (selectedRoleName === "Auditor") {
        if (!user.auditorType) {
          auditorTypeError = "Auditor type is required";
        }
      }
      let skillsError: string | undefined;
      if (selectedRoleName === "Auditor") {
        if (!user.skills || user.skills.length === 0) {
          skillsError = "At least one skill is required for Auditor";
        }
      }
      if (firstNameError || lastNameError || emailError || skillsError || auditorTypeError) {
        newFieldErrors[roleSelection] = { ...newFieldErrors[roleSelection], [index]: { firstName: firstNameError || undefined, lastName: lastNameError || undefined, email: emailError || undefined, skills: skillsError || undefined, auditorType: auditorTypeError || undefined } };
        hasErrors = true;
        if (!firstErrorMessage) {
          firstErrorMessage = firstNameError || lastNameError || emailError || skillsError || auditorTypeError || "";
        }
      }
    });
    setFieldErrors(newFieldErrors);
    if (hasErrors) {
      setMessage(createToastMessage(firstErrorMessage, "warning", 3000));
      return;
    }
    let isValid = true;
    const usersData = Object.keys(formData)
      .map((role) => {
        return formData[role]?.map((user) => {
          const roleName = roles.find(r => r.id === role)?.name;
          if (!user.firstName || !user.lastName || !user.email) {
            isValid = false;
            return null;
          }
          if (roleName === "Auditor") {
            if (!user.auditorType || user.isPrimaryAuditor === undefined || !user.skills || user.skills.length === 0) {
              isValid = false;
              return null;
            }
          }
          return {
            firstName: user.firstName, clientId: clientId, lastName: user.lastName, email: user.email, roleId: role, ...(roleName === "Auditor" ? { isPrimaryAuditor: user.isPrimaryAuditor, auditorType: user.auditorType, skills: user.skills } : {})
          };
        });
      })
      .flat()
      .filter((user) => user !== null);
    if (!isValid) {
      setMessage(createToastMessage("Please fill in all the required fields.", "warning", 3000));
      return;
    }
    if (usersData.length === 0) {
      setMessage(createToastMessage("No users to submit.", "warning", 3000));
      return;
    }
    try {
      await apiCall("post", `/api/users/process-users`, usersData);
      setMessage(createToastMessage("Users Added successfully.", "success", 3000));
      const selectedRoleName = roleSelection ? roles.find(role => role.id === roleSelection)?.name : "";
      const resetUser: Users = { firstName: "", lastName: "", email: "", ...(selectedRoleName === "Auditor" ? { isPrimaryAuditor: undefined, auditorType: undefined, skills: [] } : {}) };
      setFormData({ [roleSelection!]: Array(formData[roleSelection!].length).fill(resetUser) });
      setFieldErrors({});
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const selectedRoleName = roleSelection ? roles.find(role => role.id === roleSelection)?.name : "";
  const handleAddNewRow = () => {
    if (!roleSelection) return;
    const newUser: Users = { firstName: "", lastName: "", email: "", ...(selectedRoleName === "Auditor" ? { isPrimaryAuditor: undefined, auditorType: undefined, skills: [] } : {}) };
    setFormData({ ...formData, [roleSelection]: [...(formData[roleSelection] || []), newUser] });
  };
  const handleDeleteRow = (index: number) => {
    if (!roleSelection) return;
    const updatedUsers = [...formData[roleSelection]];
    updatedUsers.splice(index, 1);
    setFormData({ ...formData, [roleSelection]: updatedUsers });
    setFieldErrors(prev => {
      const newErrors = { ...prev };
      if (newErrors[roleSelection]) {
        delete newErrors[roleSelection][index];
        if (Object.keys(newErrors[roleSelection]).length === 0) {
          delete newErrors[roleSelection];
        }
      }
      return newErrors;
    });
  };
  const preventEnterSubmit = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };
  return (
    <div className="list-page-container">
      {showQuestion ? (
        <div className="question-container">
          <p>Do you want to add more than 10 Admins or Auditors or Function Head or Function Spoc?</p>
          <button onClick={handleYesClick} className="yes-button">Yes</button>
          <button onClick={handleNoClick} className="no-button">No</button>
          <button onClick={handleBack} className="back-button-list1">Back</button>
        </div>
      ) : showTemplateButtons ? (
        <div>
          <div className="upload-container">
            {fields.view && (
              <button onClick={handleDownloadTemplate} className="download-template-button">Download Template</button>
            )}
            {fields.upload && (
              <label onClick={() => { if (!file) { setShowUploadWarningModal(true); } }} className={`file-upload-label ${file ? "disabled" : ""}`}>
                <span className="file-upload-icon2">Choose File</span>
              </label>
            )}
            <input id="file-upload" type="file" accept=".csv, .xlsx, .json" onChange={handleFileChange} className="hidden-input" />
            {file && (
              <button onClick={handleBulkUpload} className="bulk-upload-button1"><FaUpload /> Bulk Upload</button>
            )}
            {uploadError && <p className="error-text">{uploadError}</p>}
          </div>
          <button onClick={handleBackClickGroup} type="button" className="back-button">Back</button>
        </div>
      ) : roleSelection ? (
        <div className="group-container">
          <h2>Add {selectedRoleName}</h2>
          <form onSubmit={handleFormSubmit} noValidate>
            <div className="list-container">
              <div className="group-container">
                {Array.isArray(formData[roleSelection]) && fields.create &&
                  formData[roleSelection]?.map((user, index) => {
                    return (
                      <div key={index} className="form-group-row">
                        <div className="input-wrapper">
                          <input type="text" name="firstName" value={user.firstName} onChange={(e) => handleFormChange(e, roleSelection!, index)} onKeyDown={preventEnterSubmit} placeholder="First Name" required className={fieldErrors[roleSelection]?.[index]?.firstName ? 'error' : ''} />
                          {fieldErrors[roleSelection]?.[index]?.firstName && (
                            <span className="error-message">{fieldErrors[roleSelection]?.[index]?.firstName}</span>
                          )}
                        </div>
                        <div className="input-wrapper">
                          <input type="text" name="lastName" value={user.lastName} onChange={(e) => handleFormChange(e, roleSelection!, index)} placeholder="Last Name" required className={fieldErrors[roleSelection]?.[index]?.lastName ? 'error' : ''} />
                          {fieldErrors[roleSelection]?.[index]?.lastName && (
                            <span className="error-message">{fieldErrors[roleSelection]?.[index]?.lastName}</span>
                          )}
                        </div>
                        <div className="input-wrapper">
                          <input type="email" name="email" value={user.email} onChange={(e) => handleFormChange(e, roleSelection!, index)} placeholder="Email" required className={fieldErrors[roleSelection]?.[index]?.email ? 'error' : ''} />
                          {fieldErrors[roleSelection]?.[index]?.email && (
                            <span className="error-message">{fieldErrors[roleSelection]?.[index]?.email}</span>
                          )}
                        </div>
                        {selectedRoleName === "Auditor" && (
                          <>
                            <select name="auditorType" value={user.auditorType || ""} onChange={(e) => handleFormChange(e, roleSelection!, index)} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} className="auditor-dropdown" required>
                              <option value="" disabled>Select Auditor Type</option>
                              {auditorTypes.map((type) => (
                                <option key={type.value} value={type.value}>{type.description}</option>
                              ))}
                            </select>
                            {fieldErrors[roleSelection]?.[index]?.auditorType && (
                              <span className="error-message">{fieldErrors[roleSelection]?.[index]?.auditorType}</span>
                            )}
                            <select name="isPrimaryAuditor" value={user.isPrimaryAuditor === undefined ? "" : user.isPrimaryAuditor?.toString() || ""} onChange={(e) => handleFormChange(e, roleSelection!, index)} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} className="auditor-dropdown" disabled={false} required={true} style={{ opacity: 1, cursor: 'pointer' }}>
                              <option value="" disabled>Select Auditor committee</option>
                              <option value="true">Primary Auditor</option>
                              <option value="false">Secondary Auditor</option>
                            </select>
                            <div className="input-wrapper skills-input-wrapper">
                              <div className={`skills-display-content ${fieldErrors[roleSelection]?.[index]?.skills ? 'error' : ''}`} onClick={() => handleOpenSkillsModal(roleSelection!, index)}>
                                <span className="skills-text">{getSelectedSkillsDisplay(user.skills || [])}</span>
                              </div>
                              {fieldErrors[roleSelection]?.[index]?.skills && (
                                <span className="error-message">{fieldErrors[roleSelection]?.[index]?.skills}</span>
                              )}
                            </div>
                          </>
                        )}
                        <div className="button-group">
                          {formData[roleSelection]?.length < 10 && (
                            <button type="button" onClick={handleAddNewRow} className="add-row-button" title="Add new row"><IoMdPersonAdd /></button>
                          )}
                          {formData[roleSelection]?.length > 1 && (
                            <button type="button" onClick={() => handleDeleteRow(index)} className="delete-row-button" title="Remove this row"><IoPersonRemoveSharp /></button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                {formData[roleSelection]?.length >= 10 && (
                  <p className="error-text">Maximum of 10 users allowed. Use bulk upload for more.</p>
                )}
              </div>
            </div>
            <div className="buttons">
              <button type="button" className="back-button-list" onClick={handleBackClick}>Back</button>
              {fields.create && (
                <button type="submit" className="submit-button-list">Add User</button>
              )}
            </div>
          </form>
        </div>
      ) : (
        <div className="role-selection-container">
          <label htmlFor="role-selection">Select A Group To Create:</label>
          <select id="role-selection" onChange={handleRoleSelectionChange} value={roleSelection || ""}>
            <option value="" disabled>Select a Group</option>
            {Array.isArray(roles) ? (
              roles.map((role) => (
                <option key={role.id} value={role.id}>{role.name}</option>
              ))
            ) : (
              <option disabled>Loading roles...</option>
            )}
          </select>
          <button className="back-button-list2" onClick={handleBackClickGroup}>Back</button>
        </div>
      )}
      <SkillsModal isOpen={showSkillsModal} onClose={() => setShowSkillsModal(false)} onSave={handleSaveSkills} skills={auditorSkills} selectedSkills={currentSkillRowIndex !== null && currentSkillRole !== null ? formData[currentSkillRole]?.[currentSkillRowIndex]?.skills || [] : []} />
      {showUploadWarningModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Upload Guidelines</h3>
            <p>Please ensure:</p>
            <ul>
              <li>First Name and Last Name should not contain special characters.</li>
              <li>Email must be in valid format (example: user@example.com).</li>
            </ul>
            <div className="modal-buttons">
              <button className="cancelbutton" onClick={() => setShowUploadWarningModal(false)}>Cancel</button>
              <button className="savebutton" onClick={() => { setShowUploadWarningModal(false); document.getElementById("file-upload")?.click() }}>OK</button>
            </div>
          </div>
        </div>
      )}
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default RoleMapping;